var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('register-code-registration-'+ _vm.companyCode,{tag:"component",attrs:{"register-code":_vm.registerCode,"error-message":_vm.errorMessage},on:{"error":_vm.setErrorMessage,"change":_vm.changeRegisterCode,"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }